export const AUD_PHONE_AUTH_BLOCKER_EXPERIMENT = 'aud_mobile_aud3852_phone_auth_blocker';

export const EXPERIMENTS: string[] = [AUD_PHONE_AUTH_BLOCKER_EXPERIMENT];
